import React from 'react';
import './DiamondJewellery.css';

function DiamondJewellery() {
  return (
    <div className="diamond-jewellery-page">
      {/* Hero Section */}
      <section className="jewellery-hero">
        <div className="hero-background">
          <div className="hero-overlay">
            <div className="hero-content">
              <h1 className="hero-title">Diamond Jewellery</h1>
              <p className="hero-subtitle">Sparkling Brilliance in Every Cut</p>
            </div>
          </div>
        </div>
      </section>

      {/* Collection Section */}
      <section className="collection-section">
        <div className="container">
          <h2 className="section-title">Our Diamond Collections</h2>
          <div className="jewellery-grid">
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">Diamond Rings</div>
              </div>
              <h3>Diamond Rings</h3>
              <p>Exquisite diamond rings for engagements, weddings, and special occasions</p>
            </div>
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">Diamond Necklaces</div>
              </div>
              <h3>Diamond Necklaces</h3>
              <p>Elegant diamond necklaces that add sparkle to any outfit</p>
            </div>
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">Diamond Earrings</div>
              </div>
              <h3>Diamond Earrings</h3>
              <p>Beautiful diamond earrings in various styles and cuts</p>
            </div>
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">Diamond Bracelets</div>
              </div>
              <h3>Diamond Bracelets</h3>
              <p>Stunning diamond bracelets for the perfect finishing touch</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DiamondJewellery;
